import MultiFiltering from "./dynamicPageReload/init";
import { registerAppAdjustTracking } from "./appsTracking/AppsTracking";
import { onReady } from "@otto-ec/global-resources/dom";

onReady.subscribe(() => {
  MultiFiltering.init();
  registerAppAdjustTracking();
});
